// extracted by mini-css-extract-plugin
module.exports = {"coverImage":"CoverImage_coverImage__J2oEI","actionsContainer":"CoverImage_actionsContainer__wuonq","actionButton":"CoverImage_actionButton__vu7FG"};